import { VERSION } from "./lib/utils/version.js";
import { encodeWKT } from "./lib/encode-wkt.js";
export const WKTWriter = {
  name: 'WKT (Well Known Text)',
  id: 'wkt',
  module: 'wkt',
  version: VERSION,
  extensions: ['wkt'],
  text: true,
  encode: async geometry => encodeWKTSync(geometry),
  encodeSync: encodeWKTSync,
  encodeTextSync: encodeWKT,
  options: {
    wkt: {}
  }
};
function encodeWKTSync(geometry) {
  return new TextEncoder().encode(encodeWKT(geometry)).buffer;
}
//# sourceMappingURL=wkt-writer.js.map